export default __webpack_public_path__ + "static/media/labReportOff.b7533097.svg";